import { render, staticRenderFns } from "./DepartureChecklistComponent.vue?vue&type=template&id=356ee855&scoped=true&"
import script from "./DepartureChecklistComponent.vue?vue&type=script&lang=js&"
export * from "./DepartureChecklistComponent.vue?vue&type=script&lang=js&"
import style0 from "./DepartureChecklistComponent.vue?vue&type=style&index=0&id=356ee855&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356ee855",
  null
  
)

export default component.exports